import TumengText from './src/index.vue'

TumengText.install = function(Vue) {
  Vue.component(TumengText.name, TumengText)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengText)
}

export default TumengText
